import { render, staticRenderFns } from "./ActivityLog.vue?vue&type=template&id=12cb8738&"
import script from "./ActivityLog.vue?vue&type=script&lang=js&"
export * from "./ActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports